// React
import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'

// Components
import ProductPrice from 'store/v2/react/components/product_price'
import { Switch } from 'ui/components/Switch'
import BServices from 'store/blocks/Services'

// Shared
import { triggerUserFrameworkBookEvent } from 'shared/utils/userFrameworkEvents'
import CartActions from 'store/v2/redux/actions/cart'
import { Settings as SettingsUtils } from 'back_office/v2/utils/utils'

const Service = ({ index, line, service, inCart, hasPrice, toggleService }) => {
  const [loading, setLoading] = useState(false)
  const [checked, setChecked] = useState(inCart)

  const handleChangeService = useCallback(() => {
    const value = !checked

    setLoading(true)
    toggleService(value).then(() => {
      if (checked !== value) {
        setChecked(value)
      }
    }).catch((error) => {
      console.error(error)
    }).finally(() => {
      setLoading(false)
    })
  }, [checked])

  return (
    <BServices.Service data-tid={`Service #${index + 1}`} disabled={!checked}>
      <BServices.Label className="service-label">
        {service.name}
        {' '}
        {hasPrice && SettingsUtils.get('store.use_prices') && (
          <span>
            (
            <ProductPrice
              chargeLabel={(line || service).charge_label}
              priceInCents={line?.display_price_in_cents || service?.price_in_cents}
              priceType={(line || service).price_type}
              productType={(line || service).product_type}
            />
            )
          </span>
        )}
      </BServices.Label>
      <Switch
        className="service-toggle"
        field={{ value: checked, onChange: handleChangeService }}
        disabled={loading}
        withActiveEffect={false}
        relative
        block
      />
    </BServices.Service>
  )
}

Service.displayName = 'Service'

Service.propTypes = {
  index: PropTypes.number,
  line: PropTypes.object,
  service: PropTypes.object,
  inCart: PropTypes.bool,
  hasPrice: PropTypes.bool,
  toggleService: PropTypes.func
}

const mapStateToProps = (_state, props) => {
  const hasPrice =
    props.service?.price_in_cents >= 0 &&
    props.service?.price_in_cents !== null &&
    props.service?.price_type !== 'none' &&
    props.service?.price_type !== null

  return {
    line: props.lines
      .getAll({ item_id: props.service.id })
      .reverse()
      .first(),
    checked: props.inCart,
    hasPrice
  }
}

const mapDispatchToProps = (_dispatch, props) => {
  const book = (quantity) => {
    return CartActions.book({
      item_id: props.service.id,
      quantity,
      type: 'set',
      apiVersion: 1
    }).then(() => {
      const quantityChange = quantity === 0 ? -1 : 1

      triggerUserFrameworkBookEvent(props.service.id, quantityChange)
    })
  }

  return {
    toggleService: (value) => {
      if (value) {
        return book(1)
      } else {
        return book(0)
      }
    }
  }
}

export default reduxConnect(mapStateToProps, mapDispatchToProps)(Service)
